/** IT General Controls dashboard card icon. */
export function ItgcIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14.84 1.6215C14.73 1.5315 14.59 1.4915 14.45 1.5015L9.45 2.0015C9.37 2.0115 9.29 2.0315 9.22 2.0815L8 2.8915L6.78 2.0815C6.71 2.0315 6.63 2.0115 6.55 2.0015L1.55 1.5015C1.41 1.4915 1.27 1.5315 1.17 1.6215C1.06 1.7215 1 1.8515 1 2.0015V12.4915C1 12.7315 1.17 12.9415 1.4 12.9915L6.34 13.9715L7.84 14.4715C7.84 14.4715 7.95 14.4915 8 14.4915C8.06 14.4915 8.11 14.4915 8.16 14.4715L9.6 13.9915L14.6 12.9915C14.83 12.9415 15 12.7315 15 12.4915V2.0015C15 1.8515 14.94 1.7215 14.84 1.6215ZM2 12.0815V2.5515L6.33 2.9815L7.5 3.7615V13.3015L6.6 13.0015L2 12.0815ZM14 12.0915L9.34 13.0215L8.5 13.3015V3.7615L9.68 2.9815L14 2.5515V12.0915Z"
        fill="currentColor"
      />
    </svg>
  );
}
